import { render, staticRenderFns } from "./TakipYoluList.vue?vue&type=template&id=0fefc73b"
import script from "./TakipYoluList.vue?vue&type=script&lang=ts"
export * from "./TakipYoluList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports